export interface IJobResult {
  success: boolean;
  name: string;
  id: string;
}

export interface IJobData {
  id?: number;
  skip?: number;
  take?: number;
}
